import React from 'react';
import Link from '@mui/material/Link';

function stripTrailingPunctuation(raw) {
  let s = raw;
  for (;;) {
    const m = s.match(/[.,;:!?)]+$/);
    if (!m || m[0].length === 0) break;
    s = s.slice(0, -m[0].length);
    if (s === '') break;
  }
  return s;
}

function findSchemeUrlStart(s, from) {
  let pos = from;
  while (pos < s.length) {
    const https = s.indexOf('https://', pos);
    const http = s.indexOf('http://', pos);
    const candidates = [https, http].filter((x) => x >= 0).sort((a, b) => a - b);
    const cand = candidates[0];
    if (cand === undefined) return -1;
    if (cand === 0 || /\s/.test(s[cand - 1])) return cand;
    pos = cand + 1;
  }
  return -1;
}

function findWwwStart(s, from) {
  let j = from;
  while (j < s.length) {
    const idx = s.indexOf('www.', j);
    if (idx < 0) return -1;
    if (idx === 0 || /\s/.test(s[idx - 1])) return idx;
    j = idx + 1;
  }
  return -1;
}

export function renderTextWithLinks(text) {
  if (text == null) return null;
  const s = String(text);
  if (s === '') return s;

  const out = [];
  let i = 0;
  let key = 0;

  while (i < s.length) {
    const schemeAt = findSchemeUrlStart(s, i);
    const wwwAt = findWwwStart(s, i);

    let start = -1;
    let mode = null;
    if (schemeAt >= 0 && (wwwAt < 0 || schemeAt <= wwwAt)) {
      start = schemeAt;
      mode = 'scheme';
    } else if (wwwAt >= 0) {
      start = wwwAt;
      mode = 'www';
    }

    if (start < 0) {
      out.push(s.slice(i));
      break;
    }

    if (start > i) {
      out.push(s.slice(i, start));
    }

    const rest = s.slice(start);
    const m = rest.match(/^(\S+)/);
    if (!m) break;
    const rawToken = m[1];
    const display = stripTrailingPunctuation(rawToken);

    const href = mode === 'www' ? `https://${display}` : display;

    if (mode === 'scheme' && !/^https?:\/\//i.test(href)) {
      out.push(s.slice(start, start + rawToken.length));
      i = start + rawToken.length;
      continue;
    }

    out.push(
      <Link key={`link-${key++}`} href={href} target="_blank" rel="noopener noreferrer" underline="hover" component="a">
        {display}
      </Link>
    );
    i = start + rawToken.length;
  }

  if (out.length === 1 && typeof out[0] === 'string') {
    return out[0];
  }

  return out.map((el, idx) =>
    typeof el === 'string' ? <React.Fragment key={`frag-${idx}`}>{el}</React.Fragment> : el
  );
}
